import { getScrollbarWidth } from 'core/util/dom';
import React from 'react';

const spacerStyle = { width: getScrollbarWidth() };

const ScrollbarSpacer: React.SFC = () => <div className="modal__spacer" style={spacerStyle} />;

export default ScrollbarSpacer;
